module.exports = __webpack_public_path__ + "img/app/extApp/img/icon-arrow-rg.1a6b53b0f6654568ac69c69390bd35fd.png";